package com.swetdot.swetgram.ui.chats

import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.Dp
import com.swetdot.swetgram.data.MuteDeadline
import com.swetdot.swetgram.data.MuteDuration
import com.swetdot.swetgram.domain.Chat
import com.swetdot.swetgram.domain.ChatId
import com.swetdot.swetgram.domain.ChatKind
import com.swetdot.swetgram.domain.LocalDay
import com.swetdot.swetgram.domain.PreviewBody
import com.swetdot.swetgram.domain.SPEAKER_SELF
import com.swetdot.swetgram.domain.User
import com.swetdot.swetgram.domain.UserId
import com.swetdot.swetgram.domain.preview
import com.swetdot.swetgram.ui.chat.ChatActionRow
import com.swetdot.swetgram.ui.chat.ChatDialog
import com.swetdot.swetgram.ui.chat.DayLabel
import com.swetdot.swetgram.ui.chat.dayLabel
import com.swetdot.swetgram.ui.chat.dayLabelText
import com.swetdot.swetgram.ui.chat.formatClockTime
import com.swetdot.swetgram.ui.chat.render
import com.swetdot.swetgram.ui.design.Radius
import com.swetdot.swetgram.ui.design.Sizes
import com.swetdot.swetgram.ui.design.Space
import com.swetdot.swetgram.ui.design.SwetAvatar
import com.swetdot.swetgram.ui.design.SwetAvatarFace
import com.swetdot.swetgram.ui.design.SwetBadgeStyle
import com.swetdot.swetgram.ui.design.SwetBlackBadge
import com.swetdot.swetgram.ui.design.SwetDestructiveButton
import com.swetdot.swetgram.ui.design.SwetEmptyState
import com.swetdot.swetgram.ui.design.SwetErrorBanner
import com.swetdot.swetgram.ui.design.SwetGroupAvatar
import com.swetdot.swetgram.ui.design.SwetIcon
import com.swetdot.swetgram.ui.design.SwetIconButton
import com.swetdot.swetgram.ui.design.SwetIcons
import com.swetdot.swetgram.ui.design.SwetListRow
import com.swetdot.swetgram.ui.design.SwetListRowSkeleton
import com.swetdot.swetgram.ui.design.SwetPullToRefresh
import com.swetdot.swetgram.ui.design.SwetScreenTitle
import com.swetdot.swetgram.ui.design.SwetSearchBar
import com.swetdot.swetgram.ui.design.SwetSecondaryButton
import com.swetdot.swetgram.ui.design.SwetTopAppBar
import com.swetdot.swetgram.ui.design.TouchTarget
import com.swetdot.swetgram.ui.design.chatRowDividerIndent
import com.swetdot.swetgram.ui.design.swetFloatingNavClearance
import com.swetdot.swetgram.ui.design.swetAnimateItem
import com.swetdot.swetgram.ui.design.swetPressable
import com.swetdot.swetgram.ui.design.usesGroupAvatarGrid
import com.swetdot.swetgram.ui.text.UiText
import com.swetdot.swetgram.ui.text.resolve
import com.swetdot.swetgram.ui.text.resolveOrNull
import com.swetdot.swetgram.ui.text.text
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.chatlist_action_archive
import swetgram.shared.generated.resources.chatlist_action_cancel
import swetgram.shared.generated.resources.chatlist_action_delete
import swetgram.shared.generated.resources.chatlist_action_delete_chat
import swetgram.shared.generated.resources.chatlist_action_mute
import swetgram.shared.generated.resources.chatlist_action_pin
import swetgram.shared.generated.resources.chatlist_action_restore
import swetgram.shared.generated.resources.chatlist_action_unmute
import swetgram.shared.generated.resources.chatlist_action_unpin
import swetgram.shared.generated.resources.chatlist_archive_empty_body
import swetgram.shared.generated.resources.chatlist_archive_empty_title
import swetgram.shared.generated.resources.chatlist_archived_chat_count
import swetgram.shared.generated.resources.chatlist_archived_title
import swetgram.shared.generated.resources.chatlist_archived_unread_description
import swetgram.shared.generated.resources.chatlist_delete_dialog_body
import swetgram.shared.generated.resources.chatlist_delete_dialog_title
import swetgram.shared.generated.resources.chatlist_empty_body
import swetgram.shared.generated.resources.chatlist_empty_title
import swetgram.shared.generated.resources.chatlist_mute_dialog_body
import swetgram.shared.generated.resources.chatlist_mute_dialog_title
import swetgram.shared.generated.resources.chatlist_new_chat
import swetgram.shared.generated.resources.chatlist_new_chat_description
import swetgram.shared.generated.resources.chatlist_preview_by_deleted
import swetgram.shared.generated.resources.chatlist_preview_by_empty
import swetgram.shared.generated.resources.chatlist_preview_by_photo
import swetgram.shared.generated.resources.chatlist_preview_by_voice
import swetgram.shared.generated.resources.chatlist_preview_by_text
import swetgram.shared.generated.resources.chatlist_preview_deleted
import swetgram.shared.generated.resources.chatlist_preview_empty
import swetgram.shared.generated.resources.chatlist_preview_photo
import swetgram.shared.generated.resources.chatlist_preview_voice
import swetgram.shared.generated.resources.chatlist_preview_speaker_self
import swetgram.shared.generated.resources.chatlist_row_long_press_label
import swetgram.shared.generated.resources.chatlist_row_muted_description
import swetgram.shared.generated.resources.chatlist_row_open_profile_label
import swetgram.shared.generated.resources.chatlist_search_empty_body
import swetgram.shared.generated.resources.chatlist_search_empty_title
import swetgram.shared.generated.resources.chatlist_search_placeholder
import swetgram.shared.generated.resources.chatlist_section_all_chats
import swetgram.shared.generated.resources.chatlist_section_chats
import swetgram.shared.generated.resources.chatlist_section_people
import swetgram.shared.generated.resources.chatlist_section_pinned
import swetgram.shared.generated.resources.chatlist_title
import swetgram.shared.generated.resources.chatlist_typing_preview
import swetgram.shared.generated.resources.handle_prefixed
import swetgram.shared.generated.resources.mute_choice_eight_hours
import swetgram.shared.generated.resources.mute_choice_forever
import swetgram.shared.generated.resources.mute_choice_one_day
import swetgram.shared.generated.resources.mute_choice_one_hour
import swetgram.shared.generated.resources.mute_choice_one_week
import swetgram.shared.generated.resources.mute_status_indefinite
import swetgram.shared.generated.resources.mute_status_until_date
import swetgram.shared.generated.resources.mute_status_until_today
import swetgram.shared.generated.resources.mute_status_until_yesterday
import swetgram.shared.generated.resources.value_passthrough
import kotlinx.datetime.TimeZone
import kotlin.time.Clock
import kotlin.time.Instant

/**
 * The Chats tab -- SPS §10, DRAWN TO THE USER'S MOCKUP. DECISIONS.md §26.
 *
 * The mockup overrides SDS §27.5's chrome and SPS §10.8 outright, and it is the same canvas, the
 * same black and the same house style the conversation screen was rebuilt to in §25. What changed
 * on this screen, and what did not:
 *
 *  - **The canvas is pure black, edge to edge.** `background.deep` rather than `background`, with no
 *    app-bar `Surface` over it and no divider under the title. The strip behind the status bar
 *    belongs to the app frame, which paints this route's canvas for the reason §25 records.
 *  - **The title is a screen title, not a toolbar label.** `headlineLarge` 28sp bold on the canvas,
 *    with ONE action beside it: the compose glyph that opens New Chat.
 *  - **§10.8's TWO FLOATING ACTIONS ARE GONE.** The spec requires them ("Large button: create new
 *    chat. Small button: create Discover post."); the mockup has neither and moves new-chat into the
 *    header. The user asked for the mockup. What that costs is written down in DECISIONS.md §26 and
 *    is not nothing: creating a Discover post is no longer reachable from this tab. It is not lost
 *    from the app -- `DiscoverScreen` draws its own floating action over a populated feed and its
 *    empty state carries the same `onNewPost` as a button, so both states of that tab can still
 *    reach the composer.
 *  - **The row grew.** A 52dp [Sizes.avatarChatRow] disc, an indented hairline between rows, and an
 *    unread badge that is a white disc with a black number rather than SDS §12.1's accent pill.
 *  - **A group draws its members.** Four faces in one circle -- see [SwetGroupAvatar] and
 *    [drawsMemberGrid], which decide and state what a group with fewer than four members shows.
 *
 * Everything visual is still the design system's. The row is [SwetListRow] rather than a private
 * one, so the badge cap, the preview flattening and the touch target cannot drift from every other
 * list in the app; the mockup's differences went into the design system as [SwetBadgeStyle] and the
 * row's `dividerIndent` rather than being open-coded here.
 *
 * WHAT DID NOT CHANGE IS THE POINT OF THE REST OF THIS FILE. Search with its own failure state that
 * may never fall through to "No results found." ([searchDisplay]), the Archived entry that appears
 * only when the archive is not empty, the `Pinned` label, the long-press menu, the mute-duration
 * picker, the skeletons, the empty state that is withheld over a failed first read, the error banner
 * above the list, pull-to-refresh and paging are all exactly as they were. A layout rewrite is the
 * easiest place in the world to lose a week of behaviour.
 *
 * A row carries THREE gestures: the row opens the conversation, the peer's avatar opens their
 * profile, and a long press opens the pin / mute / archive / delete menu of §10.5-10.7 and §15.3.
 * That last one is a long press rather than SDS §12.2's swipe, because a swipe needs a draggable
 * row the design system does not have -- the menu makes every one of those states reachable today,
 * and the swipe gestures are recorded as still owed.
 *
 * MUTE LIVES ON THE ROW, not in the conversation header. SPS §15.3 asks for "mute a specific chat"
 * without saying where, and SDS §12.3 gives the header only an "Optional actions menu" with no
 * contents. The row is where every other per-conversation state the user owns already is -- pin,
 * archive, delete -- and it is also where SDS §12.1's mute bell is drawn, so the control and its
 * indicator sit on the same object. A header overflow carrying exactly one item is recorded as
 * still owed rather than built here.
 */
@Composable
fun ChatListScreen(
    chats: List<Chat>,
    me: UserId,
    onOpenChat: (ChatId) -> Unit,
    modifier: Modifier = Modifier,
    /** SPS §10.4. The search field's current text; empty means the normal list is shown. */
    query: String = "",
    onQueryChange: (String) -> Unit = {},
    /** Remote people results (SPS §14.2's `People` group). Empty until a query settles. */
    people: List<User> = emptyList(),
    searching: Boolean = false,
    /** False until a query has produced an answer, so "no results" is not shown before one. */
    searchSettled: Boolean = false,
    /**
     * Why the last people lookup failed, or null when it produced an answer.
     *
     * Its own channel rather than [error], which is about the INBOX. A search that could not run
     * must not make the chat list look broken, and -- far more important -- it must not be allowed
     * to fall through to "No results found.", which is a statement about the server's records that
     * a client with no answer cannot make. See [searchDisplay].
     */
    searchError: UiText? = null,
    /** Runs the current query again. Null draws no Retry rather than an inert one. */
    onRetrySearch: (() -> Unit)? = null,
    /** SPS §10.6: the Archived entry is drawn only when this is not empty. */
    archived: List<Chat> = emptyList(),
    onOpenArchive: (() -> Unit)? = null,
    /**
     * Why the inbox read failed, as a MESSAGE rather than a sentence.
     *
     * `ChatListViewModel` picks it and cannot spell it -- `stringResource` is a `@Composable` and a
     * view model is not -- so the three failure channels on this screen all arrive as `UiText` and
     * are resolved a few lines into the body. Nothing in `Navigation.kt` had to change for it: the
     * flow's type and this parameter's type moved together.
     */
    error: UiText? = null,
    /** Null hides the banner's action: an error nobody can act on should not offer a button. */
    onRetry: (() -> Unit)? = null,
    /** The outcome of the last row action -- the pin limit, a failed archive. */
    notice: UiText? = null,
    onDismissNotice: (() -> Unit)? = null,
    /**
     * Opens someone's public profile, by USERNAME -- the key `getUserByUsername` and the
     * `user/{username}` route both take.
     */
    onOpenProfile: (String) -> Unit = {},
    /**
     * Opens SPS §10.9's New Chat flow. Null draws no compose action rather than an inert one.
     *
     * It is the HEADER's glyph now, and still the empty state's button. `onNewPost` used to sit
     * beside it as SDS §11.8's second floating action and is DELETED rather than defaulted to null:
     * the mockup removes both discs and this screen has nowhere to put a second action, so a
     * parameter for one would be a lambda no rendering path could reach. See DECISIONS.md §26 for
     * where creating a Discover post lives now.
     */
    onNewChat: (() -> Unit)? = null,
    onSetPinned: ((ChatId, Boolean) -> Unit)? = null,
    onSetArchived: ((ChatId, Boolean) -> Unit)? = null,
    onDeleteChat: ((ChatId) -> Unit)? = null,
    /**
     * SPS §15.3. A null duration unmutes; null here hides the action rather than offering an inert
     * one, exactly as the other three row actions do.
     */
    onSetMuted: ((ChatId, MuteDuration?) -> Unit)? = null,
    /**
     * When each muted conversation's mute lapses, by conversation id.
     *
     * Only ever used to LABEL a mute the row already reports through `Chat.isMuted`; a conversation
     * missing from this map and muted is shown as muted with no date. See
     * `ChatRepository.muteDeadlines` for why this is a session overlay rather than a cached column.
     */
    muteDeadlines: Map<String, MuteDeadline> = emptyMap(),
    /**
     * The conversations somebody else is typing in, by conversation id.
     *
     * The chat list is the home screen, so this is where a typing indicator is most often SEEN --
     * and it was the one surface not consuming the signal, which made the feature look broken even
     * though the frames were arriving and rendering correctly inside the open conversation.
     */
    typingChatIds: Set<String> = emptySet(),
    /** SDS §2.1: the list is refreshable by pull. Null hides the gesture rather than faking it. */
    onRefresh: (() -> Unit)? = null,
    refreshing: Boolean = false,
    /** False until the first refresh settles, so an empty cache is not called "no chats". */
    loadedOnce: Boolean = true,
    zone: TimeZone = TimeZone.currentSystemDefault(),
) {
    // Read once. Recomputing it on every recomposition would make the whole list unstable, and
    // the only thing it decides is "today or not" -- which a refresh re-evaluates anyway.
    val now = remember { Clock.System.now() }
    var actionsFor by remember { mutableStateOf<Chat?>(null) }
    var confirmDeleteOf by remember { mutableStateOf<Chat?>(null) }
    var muteFor by remember { mutableStateOf<Chat?>(null) }

    // See [belongsTo]. Everything below reads these, never the parameters.
    val mine = remember(chats, me) { chats.filter { it.belongsTo(me) } }
    val myArchive = remember(archived, me) { archived.filter { it.belongsTo(me) } }

    val isSearching = query.isNotBlank()
    // Filtered HERE rather than on the server: the list is already in memory, so these results
    // appear on the same frame as the keystroke and keep working with no network.
    val chatMatches = remember(mine, query, me) {
        if (query.isNotBlank()) mine.filter { it.matches(query, me) } else emptyList()
    }

    // The three failure channels, spelled once, here, because this is the first composable scope
    // they reach. Each stays null when there is nothing to say, so a screen with no failure does
    // no resource lookup at all -- and every `!= null` test below is the same test it was.
    //
    // RESOLVED BEFORE [failuresCoincide] SEES THEM, deliberately. That function compares the
    // SENTENCE, which its own KDoc argues for at length: two failures the design system chose to
    // describe identically are, on screen, one fact. Comparing the `UiText` instead would compare
    // the message identity, which is nearly the same thing today and is not the thing the rule is
    // about -- and it would silently stop merging the moment two keys with equal words appeared.
    val errorText = error.resolveOrNull()
    val noticeText = notice.resolveOrNull()
    val searchErrorText = searchError.resolveOrNull()

    // The mockup's first line, and the conversation screen's: pure black, edge to edge. The strip
    // behind the status bar is the app frame's -- `ui/Navigation.kt` paints this route's canvas
    // there, for the reason DECISIONS.md §25 records about the conversation.
    Column(modifier.fillMaxSize().background(SwetgramThemeTokens.colors.backgroundDeep)) {
        // WAS `SwetTopAppBar`. The mockup has no app-bar surface and no divider: a large screen
        // title sitting on the canvas with one action beside it. See [ChatsHeader].
        ChatsHeader(
            title = stringResource(Res.string.chatlist_title),
            onCompose = onNewChat,
        )

        // §11.3 and §10.4: "Search is always visible at the top of the Chats screen." Not behind
        // an icon and not collapsing on scroll.
        SwetSearchBar(
            value = query,
            onValueChange = onQueryChange,
            placeholder = stringResource(Res.string.chatlist_search_placeholder),
            // The mockup: "a ROUNDED RECTANGLE, not a pill". §11.3's own 20dp on a 48dp field is
            // 4dp short of a pill, which is the shape it says this is not. See [Radius.field].
            cornerRadius = Radius.field,
            modifier = Modifier.padding(
                start = Space.screenMargin,
                end = Space.screenMargin,
                bottom = Space.one,
            ),
        )

        // The inbox's failure and the search's, RECONCILED rather than stacked. See
        // [failuresCoincide]: offline, both requests come back with the same sentence and the
        // screen drew it twice, one banner directly under the other.
        val oneBannerForBoth = failuresCoincide(errorText, searchErrorText, isSearching)

        // Above the list, never instead of it: a failed refresh must not blank what the user
        // already had. That is exactly what SwetErrorBanner is -- a banner and not a screen.
        if (errorText != null) {
            SwetErrorBanner(
                message = errorText,
                // When this banner is speaking for the search as well, its Retry has to run both
                // requests -- otherwise the merged banner would half-work, refreshing the inbox
                // and leaving the results underneath it still missing.
                onRetry = if (oneBannerForBoth) {
                    retryBoth(onRetry, onRetrySearch)
                } else {
                    onRetry
                },
            )
        }
        // A row action that failed is reported separately from the list's own state: a rejected
        // pin must not make the whole screen look broken, and it is dismissible because nothing
        // else will clear it.
        if (noticeText != null) {
            SwetErrorBanner(message = noticeText, onDismiss = onDismissNotice)
        }
        // The SEARCH's own failure, and only while a search is on screen: it is about the results
        // below it, and it would be a non-sequitur over the inbox. SDS §29's checklist asks every
        // screen for an error state; this is the one the search area was missing entirely.
        //
        // Suppressed only when the banner above is already saying this exact sentence. When the
        // two differ they are about different things and BOTH are drawn -- a timed-out inbox
        // read and a rate-limited people lookup are two facts, and merging them would drop one.
        if (isSearching && searchErrorText != null && !oneBannerForBoth) {
            SwetErrorBanner(message = searchErrorText, onRetry = onRetrySearch)
        }

        SwetPullToRefresh(
            refreshing = refreshing,
            // Suppressed while searching: the results below are a query's answer, not the inbox,
            // and pulling on them would refetch something the user is not looking at.
            onRefresh = onRefresh?.takeIf { !isSearching },
            modifier = Modifier.weight(1f).fillMaxWidth(),
        ) {
            when {
                isSearching -> SearchResults(
                    chats = chatMatches,
                    people = people,
                    me = me,
                    now = now,
                    zone = zone,
                    searching = searching,
                    settled = searchSettled,
                    failed = searchErrorText != null,
                    onOpenChat = onOpenChat,
                    onOpenProfile = onOpenProfile,
                )

                // Nothing cached and the first read still in flight. Skeletons rather than a
                // spinner, so the real rows land exactly where the placeholders were (SDS §2.1).
                //
                // `avatarSize` IS THE HALF THAT PROMISE NEEDS. The row draws `avatarChatRow` now, so
                // a skeleton left on the 44dp default would start its text column 8dp to the left of
                // the row it stands in for and the whole list would twitch sideways on resolve.
                //
                // The clearance is applied HERE and not in `contentPadding`, because this branch does
                // not scroll: it is a plain `Column`, the floating bar is drawn over its bottom, and
                // the last placeholder would sit under the bar on any window shorter than about 660dp.
                mine.isEmpty() && !loadedOnce -> Column(
                    Modifier.fillMaxSize().padding(bottom = swetFloatingNavClearance()),
                ) {
                    repeat(SKELETON_ROWS) { SwetListRowSkeleton(avatarSize = Sizes.avatarChatRow) }
                }

                // GATED ON `error == null`, and that gate is the point of it. `loadedOnce` above
                // is set in the refresh's `finally`, so it is true after a FAILED read as well as
                // a successful one -- which meant a decode or disk failure on a cold start with an
                // empty cache painted the user's inbox as an empty account and invited them to
                // start their first conversation. That is SDS §17.2's copy used as a verdict the
                // client has no evidence for. With a banner up there this falls through to an
                // empty list instead: the banner stands alone, which is the honest rendering.
                // (Gating here rather than withholding `loadedOnce` on failure, so the skeletons
                // still resolve -- placeholders that never stop are their own false statement.)
                mine.isEmpty() && myArchive.isEmpty() && errorText == null -> SwetEmptyState(
                    // SDS §17.2's own words for this screen, with SPS §19.1's way out of it.
                    title = stringResource(Res.string.chatlist_empty_title),
                    body = stringResource(Res.string.chatlist_empty_body),
                    // The same key the New Chat screen titles itself with: the button and the
                    // screen it opens are one destination, and two keys would let them drift.
                    actionText = if (onNewChat != null) {
                        stringResource(Res.string.chatlist_new_chat)
                    } else {
                        null
                    },
                    onAction = onNewChat,
                    // `SwetEmptyState` is `fillMaxSize` with its stack CENTRED, and the region it
                    // fills now runs under the floating bar. Without this the centre is computed
                    // against the whole window and the "Start new chat" button -- the only way a
                    // brand-new account starts its first conversation from this state -- lands in
                    // the covered band on a short window (landscape, split-screen, multi-window).
                    modifier = Modifier.padding(bottom = swetFloatingNavClearance()),
                )

                else -> ChatList(
                    chats = mine,
                    archived = myArchive,
                    me = me,
                    now = now,
                    zone = zone,
                    typingChatIds = typingChatIds,
                    onOpenChat = onOpenChat,
                    onOpenProfile = onOpenProfile,
                    onOpenArchive = onOpenArchive,
                    onLongPress = { chat -> actionsFor = chat },
                )
            }

            // NOTHING FLOATS HERE ANY MORE. `AnimatedChatFabs` stood at `BottomEnd` in this Box with
            // two discs in it and is deleted, along with the `AnimatedVisibility` that hid it while
            // searching and the two glyphs it drew. DECISIONS.md §26.
        }
    }

    actionsFor?.let { chat ->
        ChatActionsDialog(
            chat = chat,
            title = chat.displayTitle(me),
            muteStatus = muteStatusLine(chat.isMuted, muteDeadlines[chat.id.value], now, zone)
                .resolveOrNull(),
            onDismiss = { actionsFor = null },
            onSetPinned = onSetPinned,
            onSetArchived = onSetArchived,
            canMute = onSetMuted != null,
            onUnmute = { target -> onSetMuted?.invoke(target.id, null) },
            onRequestMute = { target -> muteFor = target },
            canDelete = onDeleteChat != null,
            onRequestDelete = { target -> confirmDeleteOf = target },
        )
    }

    // SPS §15.3 and DECISIONS §5's five durations. Not a confirmation -- SDS §12.2 asks for one
    // only before a deletion -- but a choice, because the contract has no "mute" without a length.
    muteFor?.let { chat ->
        MuteDurationDialog(
            title = chat.displayTitle(me),
            onDismiss = { muteFor = null },
            onPick = { duration ->
                muteFor = null
                onSetMuted?.invoke(chat.id, duration)
            },
        )
    }

    // SPS §10.7 and SDS §12.2: "Delete must require confirmation."
    confirmDeleteOf?.let { chat ->
        DeleteChatDialog(
            title = chat.displayTitle(me),
            onDismiss = { confirmDeleteOf = null },
            onConfirm = {
                confirmDeleteOf = null
                onDeleteChat?.invoke(chat.id)
            },
        )
    }
}

/**
 * The Archived list -- SPS §10.6, "archived chats can be restored".
 *
 * The same rows as the inbox, so a restored chat looks identical the moment it comes back. Its
 * long-press menu offers Restore rather than Archive, which [ChatActionsDialog] derives from
 * `chat.isArchived` rather than from a flag passed down.
 */
@Composable
fun ArchivedChatsScreen(
    chats: List<Chat>,
    me: UserId,
    onOpenChat: (ChatId) -> Unit,
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    /** The same two channels the inbox takes, and `UiText` for the same reason. */
    error: UiText? = null,
    onRetry: (() -> Unit)? = null,
    notice: UiText? = null,
    onDismissNotice: (() -> Unit)? = null,
    onOpenProfile: (String) -> Unit = {},
    onSetPinned: ((ChatId, Boolean) -> Unit)? = null,
    onSetArchived: ((ChatId, Boolean) -> Unit)? = null,
    onDeleteChat: ((ChatId) -> Unit)? = null,
    onSetMuted: ((ChatId, MuteDuration?) -> Unit)? = null,
    muteDeadlines: Map<String, MuteDeadline> = emptyMap(),
    loadedOnce: Boolean = true,
    zone: TimeZone = TimeZone.currentSystemDefault(),
) {
    val now = remember { Clock.System.now() }
    var actionsFor by remember { mutableStateOf<Chat?>(null) }
    var confirmDeleteOf by remember { mutableStateOf<Chat?>(null) }
    var muteFor by remember { mutableStateOf<Chat?>(null) }

    // The same guard the inbox applies; see [belongsTo]. The archive is reached from a row whose
    // count comes from the filtered list, so an unfiltered screen behind it would disagree with
    // the number that opened it.
    val mine = remember(chats, me) { chats.filter { it.belongsTo(me) } }

    // Resolved here for the reason the inbox resolves its own, one screen up.
    val errorText = error.resolveOrNull()
    val noticeText = notice.resolveOrNull()

    // The same canvas as the inbox, because these are the same rows: `ChatRow` passes
    // `background.deep` as the online dot's border colour and as the group grid's gap, and on any
    // other fill those would read as a faint ring and four faint seams. The app bar stays -- this is
    // a pushed detail route with a Back button, not the tab.
    Column(modifier.fillMaxSize().background(SwetgramThemeTokens.colors.backgroundDeep)) {
        SwetTopAppBar(title = stringResource(Res.string.chatlist_archived_title), onBack = onBack)

        if (errorText != null) {
            SwetErrorBanner(message = errorText, onRetry = onRetry)
        }
        if (noticeText != null) {
            SwetErrorBanner(message = noticeText, onDismiss = onDismissNotice)
        }

        when {
            // No clearance here and none needed: the archive is a pushed DETAIL route, the floating
            // bar is not drawn over it, and the list below carries `navigationBarsPadding` instead.
            // The avatar size still has to match, because these rows are the same 52dp rows.
            mine.isEmpty() && !loadedOnce -> Column(Modifier.fillMaxSize()) {
                repeat(SKELETON_ROWS) { SwetListRowSkeleton(avatarSize = Sizes.avatarChatRow) }
            }

            // Gated on `error == null` for the same reason the inbox is, one screen up: a read
            // that failed is not evidence that the archive is empty.
            mine.isEmpty() && errorText == null -> SwetEmptyState(
                title = stringResource(Res.string.chatlist_archive_empty_title),
                body = stringResource(Res.string.chatlist_archive_empty_body),
            )

            // A pushed detail route: no tab bar underneath to carry the system-bar inset.
            else -> LazyColumn(Modifier.fillMaxSize().navigationBarsPadding()) {
                itemsIndexed(items = mine, key = { _, chat -> chat.id.value }) { index, chat ->
                    ChatRow(
                        modifier = swetAnimateItem(),
                        chat = chat,
                        me = me,
                        now = now,
                        zone = zone,
                        // The archive is a place chats are kept, not watched. This screen does not
                        // collect typing, so claiming it here would be guessing.
                        isTyping = false,
                        // The same rule the inbox applies: between rows, not under the last one.
                        showDivider = index < mine.lastIndex,
                        onClick = { onOpenChat(chat.id) },
                        onOpenProfile = onOpenProfile,
                        onLongPress = { actionsFor = chat },
                    )
                }
            }
        }
    }

    actionsFor?.let { chat ->
        ChatActionsDialog(
            chat = chat,
            title = chat.displayTitle(me),
            muteStatus = muteStatusLine(chat.isMuted, muteDeadlines[chat.id.value], now, zone)
                .resolveOrNull(),
            onDismiss = { actionsFor = null },
            onSetPinned = onSetPinned,
            onSetArchived = onSetArchived,
            canMute = onSetMuted != null,
            onUnmute = { target -> onSetMuted?.invoke(target.id, null) },
            onRequestMute = { target -> muteFor = target },
            canDelete = onDeleteChat != null,
            onRequestDelete = { target -> confirmDeleteOf = target },
        )
    }

    muteFor?.let { chat ->
        MuteDurationDialog(
            title = chat.displayTitle(me),
            onDismiss = { muteFor = null },
            onPick = { duration ->
                muteFor = null
                onSetMuted?.invoke(chat.id, duration)
            },
        )
    }

    confirmDeleteOf?.let { chat ->
        DeleteChatDialog(
            title = chat.displayTitle(me),
            onDismiss = { confirmDeleteOf = null },
            onConfirm = {
                confirmDeleteOf = null
                onDeleteChat?.invoke(chat.id)
            },
        )
    }
}

// ---------------------------------------------------------------------------------------------
// The list itself
// ---------------------------------------------------------------------------------------------

/** Enough placeholder rows to fill a phone screen; more would only ever be scrolled past. */
private const val SKELETON_ROWS = 7

private const val SEARCH_SKELETON_ROWS = 3

@Composable
private fun ChatList(
    chats: List<Chat>,
    archived: List<Chat>,
    me: UserId,
    now: Instant,
    zone: TimeZone,
    typingChatIds: Set<String>,
    onOpenChat: (ChatId) -> Unit,
    onOpenProfile: (String) -> Unit,
    onOpenArchive: (() -> Unit)?,
    onLongPress: (Chat) -> Unit,
    modifier: Modifier = Modifier,
) {
    // §12.1: "Pinned chats appear above normal chats." The order WITHIN each group is the
    // repository's (last activity), which §10.5 explicitly permits for v1.
    val pinned = remember(chats) { chats.filter { it.isPinned } }
    val rest = remember(chats) { chats.filterNot { it.isPinned } }

    // Which row must NOT draw a hairline under it. The mockup puts a divider "between rows", and
    // one under the last row would be a rule across the bottom of the list with nothing beneath it.
    // The last row is the last of `rest`, or the last pinned one when nothing is unpinned.
    val lastRowId = remember(pinned, rest) { (rest.lastOrNull() ?: pinned.lastOrNull())?.id }

    LazyColumn(
        modifier = modifier.fillMaxSize(),
        // ROOM FOR THE FLOATING TAB BAR, which is what this reservation is for now.
        //
        // It used to be `ChatFabStackHeight`, 148dp of two floating discs. Both discs are gone with
        // SPS §10.8, so that number reserves space for nothing -- but the reservation itself is not
        // dead, because the bar underneath stopped being a layout sibling and started floating over
        // this list (see `ui/Navigation.kt`, which opts this one screen into the overlap so the
        // black canvas can run to the bottom edge).
        //
        // `swetFloatingNavClearance()` is COMPUTED from the bar's own geometry -- its two insets,
        // its 64dp of content, and the live system gesture-bar inset, which is 0dp on a three-button
        // phone and about 34dp on an iPhone. Three screens have already shipped a hand-picked number
        // for a floating thing and all three were wrong; `fabStackHeight` exists because of it and
        // this is the same rule applied to the next thing that floats.
        contentPadding = PaddingValues(bottom = swetFloatingNavClearance()),
    ) {
        // §12.1: "Archive row appears above pinned/normal chats only if archive is not empty.
        // If archive is empty, hide it."
        if (archived.isNotEmpty() && onOpenArchive != null) {
            item(key = "archived") {
                ArchivedEntryRow(
                    count = archived.size,
                    unread = archived.sumOf { it.unreadCount },
                    // The archive row IS the last row when the inbox is empty and the archive is
                    // not -- a state the empty state above deliberately does not claim.
                    showDivider = pinned.isNotEmpty() || rest.isNotEmpty(),
                    onClick = onOpenArchive,
                )
            }
        }

        // §12.1: "Show `Pinned` section label only if at least one pinned chat exists."
        if (pinned.isNotEmpty()) {
            item(key = "pinned-header") {
                ChatSectionHeader(stringResource(Res.string.chatlist_section_pinned))
            }
            items(
                items = pinned,
                // The key is identical in both sections so pin/unpin is a move, not removal plus
                // insertion. The lists are a partition, so the same key is never emitted twice.
                key = { "chat:${it.id.value}" },
            ) { chat ->
                ChatRow(
                    modifier = swetAnimateItem(),
                    chat = chat,
                    me = me,
                    now = now,
                    zone = zone,
                    isTyping = chat.id.value in typingChatIds,
                    showDivider = chat.id != lastRowId,
                    onClick = { onOpenChat(chat.id) },
                    onOpenProfile = onOpenProfile,
                    onLongPress = { onLongPress(chat) },
                )
            }
            // A label for the rest only when there is a `Pinned` label above it to contrast
            // with; on a list with nothing pinned it would be labelling everything.
            if (rest.isNotEmpty()) {
                item(key = "all-header") {
                    ChatSectionHeader(stringResource(Res.string.chatlist_section_all_chats))
                }
            }
        }

        items(items = rest, key = { "chat:${it.id.value}" }) { chat ->
            ChatRow(
                modifier = swetAnimateItem(),
                chat = chat,
                me = me,
                now = now,
                zone = zone,
                isTyping = chat.id.value in typingChatIds,
                showDivider = chat.id != lastRowId,
                onClick = { onOpenChat(chat.id) },
                onOpenProfile = onOpenProfile,
                onLongPress = { onLongPress(chat) },
            )
        }
    }
}

/** SPS §14.2: results are grouped -- `People`, `Groups`, `Chats`. Groups have no screen yet. */
@Composable
private fun SearchResults(
    chats: List<Chat>,
    people: List<User>,
    me: UserId,
    now: Instant,
    zone: TimeZone,
    searching: Boolean,
    settled: Boolean,
    /** The people lookup failed. A banner above says so; this must not also claim emptiness. */
    failed: Boolean,
    onOpenChat: (ChatId) -> Unit,
    onOpenProfile: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val display = searchDisplay(
        hasResults = chats.isNotEmpty() || people.isNotEmpty(),
        searching = searching,
        settled = settled,
        failed = failed,
    )
    if (display != SearchDisplay.Results) {
        when (display) {
            // Still looking. Skeletons rather than "no results", which would be a wrong answer
            // shown confidently for as long as the request takes.
            // Neither of these two branches SCROLLS, so neither can reserve the bar in a
            // `contentPadding` the way the results list below does -- they take the clearance as
            // plain bottom padding instead. The bar is still over them: it is drawn for every tab
            // route, searching or not.
            SearchDisplay.Loading -> Column(
                modifier.fillMaxSize().padding(bottom = swetFloatingNavClearance()),
            ) {
                repeat(SEARCH_SKELETON_ROWS) { SwetListRowSkeleton(avatarSize = Sizes.avatarChatRow) }
            }

            // SDS §17.2's search empty state, word for word -- and only over an ANSWER.
            SearchDisplay.Empty -> SwetEmptyState(
                title = stringResource(Res.string.chatlist_search_empty_title),
                body = stringResource(Res.string.chatlist_search_empty_body),
                modifier = modifier.padding(bottom = swetFloatingNavClearance()),
            )

            // Nothing is drawn. The banner above is the whole statement, and it is the only one
            // this screen is entitled to make: a lookup that did not run says nothing at all
            // about who exists.
            SearchDisplay.Failed -> Unit

            SearchDisplay.Results -> Unit
        }
        return
    }

    LazyColumn(
        modifier = modifier.fillMaxSize(),
        // The results scroll under the floating tab bar exactly as the inbox does -- the bar is
        // still there while a search is on screen. Same computed clearance; see [ChatList], which
        // explains why it is not a number.
        contentPadding = PaddingValues(bottom = swetFloatingNavClearance()),
    ) {
        if (chats.isNotEmpty()) {
            item(key = "chats-header") {
                ChatSectionHeader(stringResource(Res.string.chatlist_section_chats))
            }
            itemsIndexed(items = chats, key = { _, chat -> "s:${chat.id.value}" }) { index, chat ->
                ChatRow(
                    chat = chat,
                    me = me,
                    now = now,
                    zone = zone,
                    // Search results answer "which conversation did I mean", and the last message
                    // is the thing that identifies one. A live state replacing it would take away
                    // the only text on the row the user is actually scanning.
                    isTyping = false,
                    // Not under the last chat: either a `People` header follows, which is its own
                    // separation, or the list ends.
                    showDivider = index < chats.lastIndex,
                    onClick = { onOpenChat(chat.id) },
                    onOpenProfile = onOpenProfile,
                    onLongPress = null,
                )
            }
        }

        if (people.isNotEmpty()) {
            item(key = "people-header") {
                ChatSectionHeader(stringResource(Res.string.chatlist_section_people))
            }
            itemsIndexed(items = people, key = { _, user -> "u:${user.id.value}" }) { index, user ->
                PersonRow(
                    user = user,
                    showDivider = index < people.lastIndex,
                    onClick = { onOpenProfile(user.username) },
                )
            }
        }
    }
}

/**
 * What the search area shows. SDS §25's states for one screen region, as one value.
 *
 * A named enum and a pure function rather than two booleans read inline, for the reason
 * `DiscoverUiState` gives about its own pair: the difference between "we have not looked yet",
 * "we looked and there is nobody" and "we could not look" is invisible in review and obvious to
 * every user, because the middle one is the only one entitled to SDS §17.2's "No results found."
 */
internal enum class SearchDisplay {
    /** A lookup is in flight, or none has settled yet. Skeletons. */
    Loading,

    /** The lookup failed. NOTHING is drawn here; the banner above says what happened. */
    Failed,

    /** The server answered, and answered with nobody. The one state that may say so out loud. */
    Empty,

    /** There is something to list. */
    Results,
}

/**
 * [SearchDisplay] from what the screen knows.
 *
 * ORDER IS THE WHOLE RULE. Results first, because a local chat match is worth showing even when
 * the remote lookup beside it fell over. Then loading, then FAILED BEFORE EMPTY -- that last pair
 * is the defect this function exists to make un-writable. Reversed, a search made offline renders
 * "No results found. Try another name or username." over a request that never left the device.
 */
internal fun searchDisplay(
    hasResults: Boolean,
    searching: Boolean,
    settled: Boolean,
    failed: Boolean,
): SearchDisplay = when {
    hasResults -> SearchDisplay.Results
    searching || !settled -> SearchDisplay.Loading
    failed -> SearchDisplay.Failed
    else -> SearchDisplay.Empty
}

/**
 * Are the inbox's failure and the search's failure THE SAME STATEMENT?
 *
 * This screen makes three separate statements above its list -- the inbox read, the last row
 * action, the people lookup -- and nothing reconciled them. Offline, the inbox read and the
 * people lookup both fail through the same `ApiError.Offline` and both render SDS §18.2's one
 * sentence for it, so the user got "No connection. Check your network and try again. Retry"
 * twice, byte for byte, stacked. Repetition is not emphasis; it reads as two problems.
 *
 * Compared by the MESSAGE rather than by the error class, because the message is what the user
 * sees: two failures the design system chose to describe identically are, on screen, one fact.
 * When the sentences differ they stay two banners -- a timed-out refresh and a rate-limited
 * search are genuinely two things, and collapsing them would delete one of them.
 *
 * Gated on [isSearching] because the search banner itself is: with no query on screen there are
 * no results for it to be about, so there is nothing to merge with.
 */
internal fun failuresCoincide(
    error: String?,
    searchError: String?,
    isSearching: Boolean,
): Boolean = isSearching && error != null && error == searchError

/**
 * One Retry for a banner that speaks for two requests, or null when neither can be re-run.
 *
 * Null rather than an empty lambda: [SwetErrorBanner] draws no action for a null `onRetry`, and
 * a button that provably does nothing is worse than no button (the rule `onRetry`'s own KDoc
 * states one screen up).
 */
private fun retryBoth(onRetry: (() -> Unit)?, onRetrySearch: (() -> Unit)?): (() -> Unit)? {
    if (onRetry == null && onRetrySearch == null) return null
    return {
        onRetry?.invoke()
        onRetrySearch?.invoke()
    }
}

/**
 * Is this conversation one of MINE?
 *
 * The server always includes the caller in `members`, so a cached row that does not name [me] did
 * not come from this account -- in practice a conversation left in the local cache by a previous
 * sign-in on the same device (the cache is cleared on sign-out now, but a row can still arrive from
 * one written by an older build).
 *
 * `Chat.peer` already refuses to answer for such a row, which is what keeps the wrong person's name
 * and online dot off it. But refusing to name it is not the same as not drawing it: the inbox was
 * still showing a 72dp row reading `Unknown`, under it a stranger's last message in full, and an
 * unread badge counting somebody else's mail. That is a developer's word on the home screen and
 * another account's content underneath it.
 *
 * So the row is DROPPED rather than relabelled. There is nothing a user can do with a conversation
 * they are not in -- opening it fetches messages the server will not serve them -- and every
 * alternative amounts to finding a nicer caption for content that should not be on the screen.
 *
 * A chat with NO members at all is kept: that is a row whose members have not loaded, not one that
 * belongs to somebody else, and hiding it would blank a real conversation.
 */
internal fun Chat.belongsTo(me: UserId): Boolean =
    members.isEmpty() || members.any { it.id == me }

/**
 * Does this conversation match what was typed?
 *
 * Title and username both, because SPS §14.1 lists "people by username" and "people by display
 * name" as separate methods and a direct chat is named after the person in it. A leading `@` is
 * stripped: it is how a user writes a handle, not part of one.
 */
internal fun Chat.matches(query: String, me: UserId): Boolean {
    val needle = query.trim().removePrefix("@").lowercase()
    if (needle.isEmpty()) return false
    if (displayTitle(me).lowercase().contains(needle)) return true
    return members.any { member ->
        member.id != me &&
            (
                member.username.lowercase().contains(needle) ||
                    member.displayName.lowercase().contains(needle)
                )
    }
}

// ---------------------------------------------------------------------------------------------
// Rows
// ---------------------------------------------------------------------------------------------

@Composable
private fun ChatRow(
    modifier: Modifier = Modifier,
    chat: Chat,
    me: UserId,
    now: Instant,
    zone: TimeZone,
    onClick: () -> Unit,
    onOpenProfile: (String) -> Unit,
    onLongPress: (() -> Unit)?,
    /**
     * Somebody else is typing in this conversation right now; the preview says so instead.
     *
     * DELIBERATELY NOT DEFAULTED. It was, and the "All chats" section then silently omitted it
     * while the "Pinned" section passed it -- so the indicator worked only for pinned chats, which
     * is the rarer case and the one least likely to be noticed. A defaulted Boolean turns a
     * forgotten argument into a plausible-looking `false` that no compiler and no test can catch.
     * Every call site now has to say which it is, including the ones that answer `false`.
     */
    isTyping: Boolean,
    /**
     * Draw the mockup's hairline under this row.
     *
     * NOT DEFAULTED EITHER, and for the reason [isTyping] states at length: five call sites emit
     * this row and each of them has a different answer for "is this the last one". A default of
     * `true` would put a rule across the bottom of every list; a default of `false` would silently
     * drop the dividers from whichever section somebody forgot, which is exactly how the typing
     * indicator ended up working for pinned chats only.
     */
    showDivider: Boolean,
) {
    val title = chat.displayTitle(me)
    val colors = SwetgramThemeTokens.colors
    // Null for a GROUP, whose avatar stands for the conversation rather than for a person, and
    // for a direct chat whose members have not loaded. Neither has a public profile behind it, so
    // neither gets the gesture: an avatar that is tappable on some rows and not others is far
    // better than one that is always tappable and sometimes navigates nowhere.
    val peer = chat.peer(me)

    SwetListRow(
        title = title,
        // Typing REPLACES the last-message preview for as long as it lasts, rather than appearing
        // beside it: the row has one line, and what somebody is doing right now is more useful
        // than what they said a moment ago -- which is still there when they stop. The signal was
        // already arriving and already rendering inside the open conversation; the home screen,
        // where it is seen most, was the surface not consuming it.
        preview = if (isTyping) {
            stringResource(Res.string.chatlist_typing_preview)
        } else {
            previewLine(chat, me).resolve()
        },
        // WHITE, like the timestamp beside an unread badge: a live state rather than content, and
        // the palette's one lift for a line that is normally secondary. NOT the accent -- that red
        // is dark enough to carry a white label on a fill and is therefore not legible as small
        // text on a card, which is the whole of what this line is.
        previewColor = if (isTyping) colors.textPrimary else null,
        // `rowTimestamp` returns a [UiText] as of the relative-date pass: three of the column's
        // four forms are copy now, so the words are resolved here rather than assembled there.
        timestamp = chat.lastMessage?.let { rowTimestamp(it.sentAt, now, zone).resolve() },
        unreadCount = chat.unreadCount,
        // The row's own click is given up so the long press can sit on the same node: a
        // `clickable` underneath a `combinedClickable` would take the tap first and the menu
        // would never open. Everything visual is still SwetListRow's.
        onClick = null,
        modifier = modifier.then(if (onLongPress == null) {
            // §25.1's pressed state through the design system rather than Material3's ripple --
            // SwetMotion.kt:333-342 says why a bare `clickable` is wrong here. The long-press
            // branch below still inherits the ripple: `combinedClickable` has no `swetPressable`
            // equivalent, and it is recorded as owed rather than open-coded here.
            Modifier.swetPressable(onClick = onClick, role = Role.Button)
        } else {
            Modifier.combinedClickable(
                role = Role.Button,
                onClick = onClick,
                onLongClickLabel = stringResource(Res.string.chatlist_row_long_press_label),
                onLongClick = onLongPress,
            )
        }),
        // SPS §10.3 / SDS §12.1: a muted chat is marked on the row. It carries its own
        // description because it is the only thing that says so -- the unread badge still
        // shows, and without this a muted chat and a noisy one are indistinguishable.
        titleTrailing = if (chat.isMuted || peer?.hasBlackBadge == true) {
            {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    if (peer?.hasBlackBadge == true) SwetBlackBadge()
                    if (peer?.hasBlackBadge == true && chat.isMuted) Spacer(Modifier.width(Space.half))
                    if (chat.isMuted) {
                        SwetIcon(
                            icon = SwetIcons.BellOff,
                            tint = colors.textSecondary,
                            size = Sizes.iconSmall,
                            contentDescription = stringResource(Res.string.chatlist_row_muted_description),
                        )
                    }
                }
            }
        } else {
            null
        },
        // The mockup: "a CIRCLE with a WHITE FILL and a BLACK number in it ... Not accent blue."
        // The timestamp above it follows the same style by construction -- see `SwetListRow`.
        badgeStyle = SwetBadgeStyle.Inverted,
        dividerIndent = if (showDivider) RowDividerIndent else null,
    ) {
        // A GROUP WITH NO PICTURE OF ITS OWN DRAWS ITS MEMBERS. See [drawsMemberGrid] for what a
        // group with fewer than four shows and why, and `SwetGroupAvatar` for the tiles.
        if (drawsMemberGrid(chat)) {
            SwetGroupAvatar(
                // Mapped here rather than in the design system: `ui/design` does not know what a
                // `User` is, and `SwetListRow`'s own KDoc is where that rule is written down.
                faces = remember(chat.members) {
                    chat.members.map { SwetAvatarFace(it.displayName, it.avatarUrl) }
                },
                size = Sizes.avatarChatRow,
                // The hairline between the four tiles takes the colour of what the disc sits on,
                // exactly as the online dot's border does. That is the black canvas here.
                surfaceColor = colors.backgroundDeep,
            )
        } else {
            SwetAvatar(
                displayName = title,
                // 52dp now, which is over TouchTarget.minimum, so the profile gesture below is
                // still comfortably above the SDS floor with no padding around it.
                size = Sizes.avatarChatRow,
                // §11.5: the online dot carries a 2dp border in the colour of what it sits on, and
                // the list sits on the mockup's pure black -- passing `background` here would leave
                // a visible #0B0B0B ring around the green.
                //
                // `isOnline` IS NEVER "UNKNOWN" HERE, and the dot is right either way. `domain.User`
                // carries a non-null Boolean and `Mappers.kt` collapses the wire's absent
                // `is_online` to `false` at the boundary, so a member whose presence is hidden by a
                // privacy setting arrives as `false` and NO DOT IS DRAWN. That is the correct
                // rendering of "not allowed to know": the component draws a dot for online and
                // nothing at all otherwise, so there is no grey dot that would assert the opposite
                // of what the setting asked for. `UserProfile.isOnline` keeps the three-way
                // distinction for the profile screen, which is the surface that needs it.
                isOnline = peer?.isOnline == true,
                surfaceColor = colors.backgroundDeep,
                // A GROUP carries its own avatar; a DIRECT chat has none of its own and is named and
                // pictured after the other participant, exactly as `displayTitle` above resolves the
                // name. Falling back the other way round would put a group's picture on a person.
                avatarUrl = chat.avatarUrl ?: peer?.avatarUrl,
                // Inside the row's own gesture, and deliberately so: a child pointer handler
                // consumes the tap first, so the avatar opens the profile and every other pixel of
                // the row still opens the conversation.
                modifier = if (peer == null) {
                    Modifier
                } else {
                    Modifier
                        // Clipped BEFORE the gesture, which `swetPressStateLayer` requires: the
                        // state layer is a plain rectangle, so an unclipped node would tint the
                        // square the avatar is laid out in rather than the circle it draws.
                        .clip(CircleShape)
                        .swetPressable(
                            role = Role.Button,
                            // The label describes the ACTION; the contentDescription below names
                            // the person. Together a screen reader reads "Alice, button, double tap
                            // to open profile" -- without the label it announces an unlabelled
                            // button, because SwetAvatar clears the semantics of its initials.
                            onClickLabel = stringResource(Res.string.chatlist_row_open_profile_label),
                            onClick = { onOpenProfile(peer.username) },
                        )
                        .semantics { contentDescription = title }
                },
            )
        }
    }
}

/** A person from search. The same 72dp row, with the handle where a preview would be. */
@Composable
private fun PersonRow(user: User, showDivider: Boolean, onClick: () -> Unit) {
    val colors = SwetgramThemeTokens.colors
    SwetListRow(
        title = user.displayName,
        titleTrailing = if (user.hasBlackBadge) ({ SwetBlackBadge() }) else null,
        // `handle_prefixed` rather than a template: the `@` is punctuation around a handle and a
        // language that writes it differently says so there, once, for every screen at once.
        preview = stringResource(Res.string.handle_prefixed, user.username),
        onClick = onClick,
        dividerIndent = if (showDivider) RowDividerIndent else null,
    ) {
        SwetAvatar(
            displayName = user.displayName,
            size = Sizes.avatarChatRow,
            isOnline = user.isOnline,
            surfaceColor = colors.backgroundDeep,
            avatarUrl = user.avatarUrl,
        )
    }
}

/**
 * SPS §10.6's Archived entry.
 *
 * Built on [SwetListRow] like every other row on this screen, so it lines up with the
 * conversations under it to the pixel -- the leading slot takes a glyph in a 44dp disc where a
 * conversation takes its avatar. The unread total goes through the row's own badge rather than
 * being drawn here, so it caps at `99+` the same way.
 */
@Composable
private fun ArchivedEntryRow(count: Int, unread: Int, showDivider: Boolean, onClick: () -> Unit) {
    val colors = SwetgramThemeTokens.colors

    // `unreadContentDescription` is a PLAIN lambda in the design system -- `SwetListRow` invokes it
    // while composing the badge -- so `pluralStringResource` cannot be called inside it and the
    // sentence is resolved out here instead. The lambda therefore ignores its argument, which is
    // the badge's own last non-zero count: the two differ for the 150ms the badge spends animating
    // out, at which point `unread` is 0 and there is no badge left to describe.
    val unreadDescription =
        pluralStringResource(Res.plurals.chatlist_archived_unread_description, unread, unread)

    SwetListRow(
        title = stringResource(Res.string.chatlist_archived_title),
        // WAS `if (count == 1) "1 chat" else "$count chats"`. That branch is English's rule and
        // nobody else's: Russian wants `чат` at 21 and `чатов` at 11, and only CLDR knows which.
        preview = pluralStringResource(Res.plurals.chatlist_archived_chat_count, count, count),
        unreadCount = unread,
        unreadContentDescription = { unreadDescription },
        badgeStyle = SwetBadgeStyle.Inverted,
        // PASSED IN, not assumed. This used to read "always: this row is never the last thing in the
        // list", on the argument that §12.1 puts the archive above the pinned and normal chats so
        // there is always a conversation under it. THE PREMISE IS FALSE: the inbox's empty state is
        // gated on `mine.isEmpty() && myArchive.isEmpty()`, so an account whose inbox is empty and
        // whose archive is not falls straight through to `ChatList` with no chats at all -- and this
        // row then painted an 84dp-indented rule across thin air at the top of a blank black screen.
        // The same happens on a failed refresh over a cold cache. `showDivider` is not defaulted for
        // exactly the reason `ChatRow`'s is not.
        dividerIndent = if (showDivider) RowDividerIndent else null,
        onClick = onClick,
    ) {
        Box(
            modifier = Modifier
                // The conversation avatar's size, so the glyph disc lines up with the photos under
                // it and the indented hairline starts at the same x on every row.
                .size(Sizes.avatarChatRow)
                .clip(CircleShape)
                .background(colors.card),
            contentAlignment = Alignment.Center,
        ) {
            // Decorative: the row's own title says "Archived", so announcing the box again would
            // have a screen reader read the word twice.
            SwetIcon(
                icon = SwetIcons.Archive,
                tint = colors.textSecondary,
                contentDescription = null,
            )
        }
    }
}

/** A list group heading. §5.3's `label.medium`, in secondary text. */
@Composable
private fun ChatSectionHeader(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = SwetgramThemeTokens.colors.textSecondary,
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = Space.screenMargin, vertical = Space.one),
    )
}

// ---------------------------------------------------------------------------------------------
// The header
// ---------------------------------------------------------------------------------------------

/*
 * WHAT USED TO BE HERE: `PrimaryFabSize` (56dp), `SecondaryFabSize` (44dp), `ChatFabStackHeight`
 * (148dp), `AnimatedChatFabs` and `ChatFabs` -- SPS §10.8's two floating actions and the reservation
 * the list made for them. All five are DELETED rather than hidden behind a flag, because the mockup
 * has no floating actions at all and a `visible = false` disc is a decision left ajar. The
 * new-chat action moved into the header below; the Discover composer's second entrance is gone from
 * this tab entirely and DECISIONS.md §26 says so out loud. `fabStackHeight` itself is untouched --
 * Discover and Groups still float their own.
 */

/** Where the mockup's hairline starts. Derived from the avatar; see [chatRowDividerIndent]. */
private val RowDividerIndent: Dp = chatRowDividerIndent(Sizes.avatarChatRow)

/**
 * Does this row draw the four-face grid instead of a single disc?
 *
 * A rule rather than a condition inline in the row, so it can be asserted on a host with no
 * renderer -- and because it is the one place the KIND is checked. [usesGroupAvatarGrid] knows
 * nothing about conversations by design: a DIRECT chat also has a null `avatarUrl` and a member
 * list, and asking the design system to tell a two-person conversation from a group would be
 * teaching it what a `Chat` is.
 *
 * The member threshold and the "a group with its own picture keeps it" rule are both stated on
 * [usesGroupAvatarGrid], which is where the reasoning lives.
 */
internal fun drawsMemberGrid(chat: Chat): Boolean =
    chat.kind == ChatKind.GROUP && usesGroupAvatarGrid(chat.avatarUrl, chat.members.size)

/**
 * The mockup's header: the screen's name, large, on the canvas, with one action beside it.
 *
 * NOT `SwetTopAppBar`, and the difference is not cosmetic. That component is §11.7's 56dp bar on a
 * `surface` fill with an optional divider under it -- a TOOLBAR. The mockup reads as a screen title
 * instead: "the word «Чаты» large, white, bold, left-aligned on the black -- clearly a screen title
 * rather than a toolbar label; it reads around 28-32sp", on a canvas with "no app-bar surface, no
 * divider under the title". Bending the shared bar into that would have left every other screen's
 * chrome carrying two shapes and one name.
 *
 * `headlineLarge` is 28sp/Bold -- the bottom of the mockup's stated band and an EXISTING §5.3 role
 * (`title.large`, "main screen title"), rather than a size invented between two rungs.
 *
 * The action is null-safe: no `onCompose` draws no button, which is the same rule the old floating
 * action followed and the reason a host that cannot start a chat does not offer to.
 */
@Composable
private fun ChatsHeader(title: String, onCompose: (() -> Unit)?) {
    // Hoisted: `SwetIconButton` takes the description as a plain String parameter, and the resource
    // lookup is composable.
    val composeDescription = stringResource(Res.string.chatlist_new_chat_description)

    SwetScreenTitle(
        title = title,
        action = onCompose?.let {
            {
                SwetIconButton(
                    // SDS §22.4 names this string exactly: "Start new chat". Same key the deleted
                    // floating action used, renamed off `fab_` because there is no FAB any more.
                    contentDescription = composeDescription,
                    onClick = it,
                ) { tint ->
                    // The mockup: "ONE outlined glyph: a square with a pencil through it ... around
                    // 24-26dp, white". `iconMedium` is 24dp, inside that band and already on §9.4's
                    // ladder; the tint is `SwetIconButton`'s, which is `text.primary`.
                    SwetIcon(icon = SwetIcons.CreateChat, tint = tint, contentDescription = null)
                }
            }
        },
    )
}


// ---------------------------------------------------------------------------------------------
// The long-press menu
// ---------------------------------------------------------------------------------------------

/**
 * The per-chat actions of SPS §10.5-10.7 and §15.3.
 *
 * Every entry is derived from the conversation's own state rather than from a flag, so a pinned
 * chat offers Unpin, a muted one offers Unmute and an archived one offers Restore without the
 * caller having to say which. Delete is last and in `danger` (§11.1), separated from the rest as
 * §12.5 requires, and it opens a confirmation rather than acting.
 *
 * [muteStatus] is the one line that is not an action: for a muted chat it says how long the mute
 * has left, which is the only place in the app that fact is visible. It is a plain sentence rather
 * than a subtitle on the Unmute row so that a screen reader reads it with the conversation's name
 * instead of as part of a control's label.
 */
@Composable
private fun ChatActionsDialog(
    chat: Chat,
    title: String,
    muteStatus: String?,
    onDismiss: () -> Unit,
    onSetPinned: ((ChatId, Boolean) -> Unit)?,
    onSetArchived: ((ChatId, Boolean) -> Unit)?,
    canMute: Boolean,
    onUnmute: (Chat) -> Unit,
    onRequestMute: (Chat) -> Unit,
    canDelete: Boolean,
    onRequestDelete: (Chat) -> Unit,
) {
    val colors = SwetgramThemeTokens.colors

    ChatDialog(onDismiss = onDismiss) {
        Text(
            text = title,
            style = MaterialTheme.typography.titleLarge,
            color = colors.textPrimary,
        )
        if (muteStatus != null) {
            Spacer(Modifier.height(Space.half))
            Text(
                text = muteStatus,
                style = MaterialTheme.typography.bodySmall,
                // Secondary, not tertiary: §22.1 keeps `text.tertiary` for placeholder and
                // disabled text only -- it measures 2.31:1 on a light card, and this is content.
                color = colors.textSecondary,
            )
        }
        Spacer(Modifier.height(Space.two))

        if (onSetPinned != null) {
            ChatActionRow(
                text = if (chat.isPinned) {
                    stringResource(Res.string.chatlist_action_unpin)
                } else {
                    stringResource(Res.string.chatlist_action_pin)
                },
                onClick = {
                    onDismiss()
                    onSetPinned(chat.id, !chat.isPinned)
                },
            )
        }
        if (canMute) {
            ChatActionRow(
                // The ellipsis says the second half opens a choice rather than acting, which is
                // the difference between this entry and every other one in the menu. It is part
                // of `chatlist_action_mute`'s value rather than appended here, so a language that
                // punctuates an unfinished action differently can say so.
                text = if (chat.isMuted) {
                    stringResource(Res.string.chatlist_action_unmute)
                } else {
                    stringResource(Res.string.chatlist_action_mute)
                },
                onClick = {
                    onDismiss()
                    if (chat.isMuted) onUnmute(chat) else onRequestMute(chat)
                },
            )
        }
        if (onSetArchived != null) {
            ChatActionRow(
                text = if (chat.isArchived) {
                    stringResource(Res.string.chatlist_action_restore)
                } else {
                    stringResource(Res.string.chatlist_action_archive)
                },
                onClick = {
                    onDismiss()
                    onSetArchived(chat.id, !chat.isArchived)
                },
            )
        }
        if (canDelete) {
            ChatActionRow(
                text = stringResource(Res.string.chatlist_action_delete_chat),
                destructive = true,
                onClick = {
                    onDismiss()
                    onRequestDelete(chat)
                },
            )
        }

        Spacer(Modifier.height(Space.two))
        SwetSecondaryButton(
            text = stringResource(Res.string.chatlist_action_cancel),
            onClick = onDismiss,
        )
    }
}

/**
 * How long to mute for -- the contract's five durations, in the order DECISIONS §5 lists them.
 *
 * NOT a confirmation. SDS §12.2 requires one before a deletion and before nothing else, and this
 * dialog exists because `muteConversation` has no "just mute it" form: `duration` is a required
 * field, so the length has to come from somewhere and guessing one on the user's behalf would be
 * the app choosing how long their notifications stay off.
 *
 * "Forever" is the contract's own word for the last option and is offered as "Until I turn it back
 * on", which is what it actually means here: it is reversed from the same menu entry that set it,
 * which is also the way back SDS §12.2 asks for on a reversible action.
 */
@Composable
private fun MuteDurationDialog(
    title: String,
    onDismiss: () -> Unit,
    onPick: (MuteDuration) -> Unit,
) {
    val colors = SwetgramThemeTokens.colors

    ChatDialog(onDismiss = onDismiss) {
        Text(
            // WAS `"Mute $title"`, which put an English verb against a Russian name on one line in
            // the title slot. The name is `displayTitle`, so it is whatever the peer called
            // themselves and may be any script; it goes in as an ARGUMENT and the sentence around
            // it is the language's own. Russian puts it after a colon, in the nominative, because
            // the accusative its verb phrase would want cannot be applied to a name the copy has
            // never seen.
            text = stringResource(Res.string.chatlist_mute_dialog_title, title),
            style = MaterialTheme.typography.titleLarge,
            color = colors.textPrimary,
        )
        Spacer(Modifier.height(Space.half))
        Text(
            // What a mute does and does not do, taken from DECISIONS §5 and §15.3 rather than
            // implied: a user who thinks muting hides the conversation will not use it twice.
            //
            // English addresses the reader here and Russian may not (DECISIONS §24). The Russian
            // value is recast around the NOTIFICATIONS rather than translated, which is why this
            // is one key with two differently-shaped sentences under it and not a template.
            text = stringResource(Res.string.chatlist_mute_dialog_body),
            style = MaterialTheme.typography.bodySmall,
            color = colors.textSecondary,
        )
        Spacer(Modifier.height(Space.two))

        MUTE_CHOICES.forEach { (duration, label) ->
            ChatActionRow(text = label.resolve(), onClick = { onPick(duration) })
        }

        Spacer(Modifier.height(Space.two))
        SwetSecondaryButton(
            text = stringResource(Res.string.chatlist_action_cancel),
            onClick = onDismiss,
        )
    }
}

/**
 * The five durations `muteConversation` accepts, with the words the user sees.
 *
 * A list rather than an exhaustive `when`, so the order on screen is stated once and matches
 * DECISIONS §5. Adding a sixth duration to the contract would leave this list short rather than
 * failing to compile -- which is the right failure for a client that must keep working against a
 * server newer than itself.
 */
private val MUTE_CHOICES: List<Pair<MuteDuration, UiText>> = listOf(
    MuteDuration.ONE_HOUR to Res.string.mute_choice_one_hour.text(),
    MuteDuration.EIGHT_HOURS to Res.string.mute_choice_eight_hours.text(),
    MuteDuration.ONE_DAY to Res.string.mute_choice_one_day.text(),
    MuteDuration.ONE_WEEK to Res.string.mute_choice_one_week.text(),
    MuteDuration.FOREVER to Res.string.mute_choice_forever.text(),
)

/**
 * What the actions menu says about a muted conversation, or null for one that is not muted.
 *
 * THE TRAP, on the client side. A `forever` mute is stored as a far-future sentinel because the
 * column derives `is_muted` from `muted_until IS NOT NULL` and NULL there means NOT muted -- so the
 * one thing this function must never do is print that date. It cannot: [MuteDeadline.Indefinite]
 * carries no instant, and `muteDeadlineOf` maps both the absent deadline the server actually sends
 * and any date past the year 9000 onto it.
 *
 * The same sentence covers the case where the deadline is simply not known yet -- a cold start
 * before the first refresh, where `isMuted` comes from the cache and the deadline does not. Saying
 * "Muted" there is true; claiming it never ends would not be.
 */
internal fun muteStatusLine(
    isMuted: Boolean,
    deadline: MuteDeadline?,
    now: Instant,
    zone: TimeZone,
): UiText? {
    if (!isMuted) return null
    val until = (deadline as? MuteDeadline.Until)?.at ?: return Res.string.mute_status_indefinite.text()
    // The clock and the date are VALUES the formatter produced, not copy, so they travel as format
    // arguments. That is also what keeps the sentence reorderable: Russian is free to put the date
    // and the time in the other order, which a Kotlin template would have fixed forever.
    val clock = formatClockTime(until, zone)
    // A SENTENCE with the day inside it, not a bare label, so the `Weekday` branch renders the date. The
    // weekday form is an abbreviation -- «Пн» -- and «Уведомления отключены до Пн» is not Russian;
    // it would need «до понедельника», which no abbreviation can supply. `TimeFormat.dayLabel`
    // records the split. A mute deadline is also almost always in the FUTURE, which that rule sends
    // to a date anyway, so this argument is about the one lapsed-mute frame below rather than a
    // whole branch.
    return when (val label = dayLabel(LocalDay.of(until, zone), now, zone)) {
        DayLabel.Today -> Res.string.mute_status_until_today.text(clock)
        // Unreachable in practice -- a deadline in the past reads as unmuted -- but a mute that
        // lapses between the refresh and this frame must not render as a bare time with no date.
        DayLabel.Yesterday -> Res.string.mute_status_until_yesterday.text(clock)
        // Unreachable given the argument above, and it prints the DATE rather than throwing: if
        // somebody ever turns weekdays on here, the sentence still reads correctly instead of
        // needing this branch discovered first.
        is DayLabel.Weekday -> Res.string.mute_status_until_date.text(label.day.render(), clock)
        is DayLabel.Absolute -> Res.string.mute_status_until_date.text(label.day.render(), clock)
    }
}

/** SPS §10.7 and SDS §12.2: deletion is confirmed, and the copy names what actually happens. */
@Composable
private fun DeleteChatDialog(
    title: String,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit,
) {
    val colors = SwetgramThemeTokens.colors

    ChatDialog(onDismiss = onDismiss) {
        Text(
            text = stringResource(Res.string.chatlist_delete_dialog_title),
            style = MaterialTheme.typography.titleLarge,
            color = colors.textPrimary,
        )
        Spacer(Modifier.height(Space.one))
        Text(
            // Exactly what the contract's `scope: self` does, and no more. Promising that the
            // other person loses their copy too would be false.
            text = stringResource(Res.string.chatlist_delete_dialog_body, title),
            style = MaterialTheme.typography.bodyMedium,
            color = colors.textSecondary,
        )
        Spacer(Modifier.height(Space.three))
        SwetDestructiveButton(
            text = stringResource(Res.string.chatlist_action_delete),
            onClick = onConfirm,
        )
        Spacer(Modifier.height(Space.one))
        SwetSecondaryButton(
            text = stringResource(Res.string.chatlist_action_cancel),
            onClick = onDismiss,
        )
    }
}

// ---------------------------------------------------------------------------------------------
// Row copy
// ---------------------------------------------------------------------------------------------

/**
 * The row's one-line summary, as a MESSAGE CHOSEN rather than a string built.
 *
 * `Chat.preview` returns a speaker and a body, and this used to glue them with
 * `append("$speaker: ")` and then append one of four English phrases. Every part of that was wrong
 * for anything but English: the separator was fixed, the order was fixed, and the four phrases were
 * literals in Kotlin where no lint and no translator could reach them.
 *
 * EIGHT KEYS, SPLIT BY WHETHER THERE IS A SPEAKER AT ALL. The bare four are what a direct chat
 * shows -- the peer's name is already the row's title, so `Chat.preview` returns no speaker and
 * repeating it would spend the only line on the word directly above it. The `_by_` four carry the
 * speaker as `%1$s`. Nothing is assembled from two translated fragments: each body is written out
 * inside its own sentence, in both languages.
 *
 * WHY A NAME IN A SLOT IS SAFE HERE and was not in the moderation confirmation. `%1$s` is a speaker
 * in the NOMINATIVE followed by a colon. Nothing after the colon has to agree with it, so the
 * sentence does not need to know the gender, number or case of a value it has never seen. The
 * moderation dialog failed exactly that test and had to be split into one sentence per target kind.
 *
 * The self speaker travels the same way -- as the ARGUMENT `chatlist_preview_speaker_self`, which
 * [UiText.resolve] unwraps before substituting. It is a word in a name slot, not a fragment of the
 * sentence: swap it for "Alex" and the grammar is unchanged. Russian says «Я» there rather than
 * «Вы», which DECISIONS §24 forbids and `CopyLintTest` refuses.
 *
 * The message TEXT and the speaker's display name are values rather than copy, so both ride
 * `value_passthrough` -- the one key that can carry an argument and can never carry a literal.
 *
 * Flattening and truncation are still NOT done here: [SwetListRow] applies `singleLinePreview`
 * itself, so every list in the app clips the same way.
 */
internal fun previewLine(chat: Chat, me: UserId): UiText {
    val (speaker, body) = chat.preview(me)

    val speakerText: UiText? = when (speaker) {
        SPEAKER_SELF -> Res.string.chatlist_preview_speaker_self.text()
        null -> null
        else -> Res.string.value_passthrough.text(speaker)
    }

    if (speakerText == null) {
        return when (body) {
            is PreviewBody.Text -> Res.string.value_passthrough.text(body.value)
            PreviewBody.Photo -> Res.string.chatlist_preview_photo.text()
            PreviewBody.Voice -> Res.string.chatlist_preview_voice.text()
            PreviewBody.Deleted -> Res.string.chatlist_preview_deleted.text()
            PreviewBody.Empty -> Res.string.chatlist_preview_empty.text()
        }
    }

    return when (body) {
        is PreviewBody.Text -> Res.string.chatlist_preview_by_text.text(speakerText, body.value)
        PreviewBody.Photo -> Res.string.chatlist_preview_by_photo.text(speakerText)
        PreviewBody.Voice -> Res.string.chatlist_preview_by_voice.text(speakerText)
        PreviewBody.Deleted -> Res.string.chatlist_preview_by_deleted.text(speakerText)
        PreviewBody.Empty -> Res.string.chatlist_preview_by_empty.text(speakerText)
    }
}

/**
 * SDS §12.1's `Time` field, in the mockup's four forms: «09:41», «Вчера», «Пн», then a date.
 *
 * WHAT THIS USED TO BE, because the shape of the fix is the point. It was
 * `if (day == today) formatClockTime(...) else day.render()`, so a message from yesterday read
 * «09.08.2026». Two of the mockup's four forms did not exist and a third was the wrong shape --
 * and the reason the previous pass left it is that `render()` is also the conversation's day
 * separators and Discover's bylines, so fixing this row alone would have put two date formats one
 * tap apart.
 *
 * SO THE RULE IS NOT HERE. `dayLabel` decides which of the four forms applies and `dayLabelText`
 * says the words, both in `chat/TimeFormat.kt`, and the conversation's separators and Discover's
 * bylines are already calling them. What is left in this function is the ONE thing that is true of
 * this column and of nothing else: a row from TODAY shows a clock where every other surface shows
 * the word "Today", because a chat list sorted by recency is read for how long ago, and the top of
 * it would otherwise be a stack of identical «Сегодня».
 *
 * WRITTEN AS AN `if` AND DELIBERATELY NOT AS A SECOND `when` OVER [DayLabel]. Everything that is
 * not today is `dayLabelText()` verbatim, so a fifth label added later reaches this column without
 * anybody remembering it exists. A `when` here would be the defect the last pass deleted from the
 * chat screen, rebuilt in a new file.
 *
 * 24-hour, from the same [formatClockTime] the bubbles use. A row reading `6:05 PM` above a
 * bubble reading `18:05` is the kind of inconsistency that makes an app feel assembled rather
 * than designed. It returns a [UiText] rather than a `String` because three of the four forms are
 * now COPY: only the clock is a value, and it travels as an argument like every other value.
 */
internal fun rowTimestamp(sentAt: Instant, now: Instant, zone: TimeZone): UiText {
    val label = dayLabel(LocalDay.of(sentAt, zone), now, zone)
    return if (label == DayLabel.Today) {
        Res.string.value_passthrough.text(formatClockTime(sentAt, zone))
    } else {
        label.dayLabelText()
    }
}
